import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "line-right",
  "use": "line-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"line-right\"><path d=\"M10.78 8.667 8.393 11.06l.94.94 4-4-4-4-.94.94 2.387 2.393H2.667v1.334z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol